import { defineStore } from 'pinia'
import { useRouter } from 'vue2-helpers/vue-router'
import { watch } from 'vue';

export const useProductFinderStore = defineStore({
    id: 'product-finder',
    state: () => ({
        map: [],
        pages: [
            {
                pageName: 'Weight',
                question: 'What is the approximate weight of your patient?',
                tooltip: `<h3>Under</h3><p>Lorem ipsum dolor sit amet consectetur adipiscing elit, ligula bibendum mi mauris erat. Natoque ut euismod viverra velit id purus, nisi magnis platea luctus sociosqu, commodo pellentesque.</p> <h3>Over</h3><p>Lorem ipsum dolor sit amet consectetur adipiscing elit, ligula bibendum mi mauris erat. Natoque ut euismod viverra velit id purus, nisi magnis platea luctus sociosqu, commodo pellentesque.</p>`,
                fields: [
                    {
                        type: 'radio', 
                        options: [
                            { label: 'Under 200 kg (31.5 stone / 440 lb)', value: 'under315' },
                            { label: 'Over 200 kg (31.5 stone / 440 lb)', value: 'over315' },
                        ]
                    },
                ],
                routeName: 'Weight',
                required: true
            },
            {
                pageName: 'Transfer Method',
                question: 'How does the patient transfer?',
                tooltip: `<h3>Under</h3><p>Lorem ipsum dolor sit amet consectetur adipiscing elit, ligula bibendum mi mauris erat. Natoque ut euismod viverra velit id purus, nisi magnis platea luctus sociosqu, commodo pellentesque.</p> <h3>Over</h3><p>Lorem ipsum dolor sit amet consectetur adipiscing elit, ligula bibendum mi mauris erat. Natoque ut euismod viverra velit id purus, nisi magnis platea luctus sociosqu, commodo pellentesque.</p>`,
                fields: [
                    {
                        type: 'radio', 
                        options: [
                            { label: 'Patient Lift / Hoist', value: 'patientLift' },
                            { label: 'Mobile or Uses Standing Equipment', value: 'mobileOrUsesStandingEquipment' },
                            { label: 'Lateral / Side Transfer', value: 'lateralTransfer' },
                            { label: 'Patient Transfers Independently', value: 'independantly' },
                        ]
                    },
                ],
                routeName: 'TransferMethod',
                required: true
            },
            {
                pageName: 'Fall Risk',
                question: 'Is the patient at risk of falling or or do they exhibit behaviours that challenge?',
                tooltip: `<h3>Utter</h3><p>Lorem ipsum dolor sit amet consectetur adipiscing elit, ligula bibendum mi mauris erat. Natoque ut euismod viverra velit id purus, nisi magnis platea luctus sociosqu, commodo pellentesque.</p> <h3>Utter</h3><p>Lorem ipsum dolor sit amet consectetur adipiscing elit, ligula bibendum mi mauris erat. Natoque ut euismod viverra velit id purus, nisi magnis platea luctus sociosqu, commodo pellentesque.</p>`,
                fields: [
                    {
                        type: 'radio', 
                        options: [
                            { label: 'Yes', value: 'yes' },
                            { label: 'No', value: 'no' },
                            // { label: 'N/A', value: '' }
                        ]
                    },
                ],
                routeName: 'FallRisk',
                required: true
            },
            {
                pageName: 'Repositioning',
                question: 'Does patient require frequent repositioning?',
                tooltip: `<h3>Utter</h3><p>Lorem ipsum dolor sit amet consectetur adipiscing elit, ligula bibendum mi mauris erat. Natoque ut euismod viverra velit id purus, nisi magnis platea luctus sociosqu, commodo pellentesque.</p> <h3>Utter</h3><p>Lorem ipsum dolor sit amet consectetur adipiscing elit, ligula bibendum mi mauris erat. Natoque ut euismod viverra velit id purus, nisi magnis platea luctus sociosqu, commodo pellentesque.</p>`,
                fields: [
                    {
                        type: 'radio', 
                        options: [
                            { label: 'Yes', value: 'yes' },
                            { label: 'No', value: 'no' },
                            // { label: 'N/A', value: '' }
                        ]
                    },
                ],
                routeName: 'Repositioning',
                required: true
            },
            {
                pageName: 'Stand',
                question: 'Can the patient stand independently?',
                tooltip: `<h3>Utter</h3><p>Lorem ipsum dolor sit amet consectetur adipiscing elit, ligula bibendum mi mauris erat. Natoque ut euismod viverra velit id purus, nisi magnis platea luctus sociosqu, commodo pellentesque.</p> <h3>Utter</h3><p>Lorem ipsum dolor sit amet consectetur adipiscing elit, ligula bibendum mi mauris erat. Natoque ut euismod viverra velit id purus, nisi magnis platea luctus sociosqu, commodo pellentesque.</p>`,
                fields: [
                    {
                        type: 'radio', 
                        options: [
                            { label: 'Yes', value: 'yes' },
                            { label: 'No', value: 'no' },
                            // { label: 'N/A', value: '' }
                        ]
                    },
                ],
                routeName: 'Stand',
                required: true
            },
            {
                pageName: 'Head Control',
                question: 'Does the patient have good head control?',
                tooltip: `<h3>Utter</h3><p>Lorem ipsum dolor sit amet consectetur adipiscing elit, ligula bibendum mi mauris erat. Natoque ut euismod viverra velit id purus, nisi magnis platea luctus sociosqu, commodo pellentesque.</p> <h3>Utter</h3><p>Lorem ipsum dolor sit amet consectetur adipiscing elit, ligula bibendum mi mauris erat. Natoque ut euismod viverra velit id purus, nisi magnis platea luctus sociosqu, commodo pellentesque.</p>`,
                fields: [
                    {
                        type: 'radio', 
                        options: [
                            { label: 'Yes', value: 'yes' },
                            { label: 'No', value: 'no' },
                            // { label: 'N/A', value: '' }
                        ]
                    },
                ],
                routeName: 'HeadControl',
                required: true
            },
            {
                pageName: 'Recommendations',
                routeName: 'Recommendations',
                required: false
            },
        ],
        currentStep: 0,
        selectedOptions: ['', '', '', '', '', ''],
        router: useRouter(),
        loading: false,
        submissionForm: [],
        resultProducts: [],
    }),
    actions: {
        setSelectedOption(option) {
            // this.selectedOptions = this.selectedOptions.slice(0, this.currentStep);
            this.selectedOptions[this.currentStep] = option || '';
            this.saveStateToLocalStorage();
        },
        startAgain() {
            this.currentStep = 0;
            this.selectedOptions = ['', '', '', '', '', ''],
            this.loading = false;
            this.submissionForm = [];
            this.resultProducts = [];
            this.saveStateToLocalStorage();
            this.setStep(0);

            if (!this.router.currentRoute.path.includes('gb-ie')) {
                this.router.push('/seating-solution-finder');
            } else {
                this.router.push('/gb-ie/seating-solution-finder');
            }
        },
        setStep(step) {
            this.currentStep = step;
            this.saveStateToLocalStorage();

            if (!this.router.currentRoute.path.includes('gb-ie')) {
                let path = this.router.options.routes[this.currentStep].path;
                this.router.push(path);
            } else {
                let path = '/gb-ie' + this.router.options.routes[this.currentStep].path;
                this.router.push(path);
            }
        },
        nextStep() {
            if (this.currentStep < this.pages.length - 1) {
                this.currentStep = this.currentStep + 1;
                this.saveStateToLocalStorage();

                if (!this.router.currentRoute.path.includes('gb-ie')) {
                    let path = this.router.options.routes[this.currentStep].path;
                    this.router.push(path);
                } else {
                    let path = '/gb-ie' + this.router.options.routes[this.currentStep].path;
                    this.router.push(path);
                }
            }
        },
        prevStep() {
            if (this.currentStep >= 0) {
                this.currentStep = this.currentStep - 1;
                this.router.push({ name: this.pages[this.currentStep].routeName });
                this.saveStateToLocalStorage();
            }
        },
        clear() {
            this.selectedOptions = ['', '', '', '', '', ''],
            this.loading = false;
            this.submissionForm = [];
            this.resultProducts = [];
            this.saveStateToLocalStorage();
        },
        saveStateToLocalStorage() {
            const state = {
                currentStep: this.currentStep,
                selectedOptions: this.selectedOptions,
            };
            localStorage.setItem('productFinderState', JSON.stringify(state));
        },
        loadStateFromLocalStorage() {
            const savedState = localStorage.getItem('productFinderState');

            if (savedState) {
                const parsedState = JSON.parse(savedState);
                this.currentStep = parsedState.currentStep || 0;
                this.selectedOptions = parsedState.selectedOptions || [];
            }
        }
    },
    getters: {
        initialized() {
            this.loadStateFromLocalStorage()
        }
    },
});
